export const DIRECTORY_ATTRIBUTES = [
  'directory',
  'webkitdirectory',
  'mozdirectory',
];
